import { Component, OnInit } from "@angular/core";
import { CatCallesService } from "../../servicios/cat-calles.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatCalles } from "../../entidades/entidades";
import { CatColoniasService } from "app/servicios/cat-colonias.service";
import { CatDelegacionesService } from "app/servicios/cat-delegaciones.service";
@Component({
  selector: "app-cat-calles-grid",
  templateUrl: "./cat-calles-grid.component.html",
  styleUrls: ["./cat-calles-grid.component.css"],
})
export class CatCallesGridComponent implements OnInit {
  public muestraMensaje = new MuestraMensaje();
  public catCalles: CatCalles[];
  public itemsMenu: MenuItem[];
  public columnasTabla: any[];
  public clonedCatCalles: { [s: string]: CatCalles } = {};
  public catColonia: SelectItem[];
  public catDelegaciones: SelectItem[];
  public idColoniaSelect: number;
  public idDelegacionSelect: number;
  public progressBar: boolean = false;  

  constructor(
   private catDelegacionesService: CatDelegacionesService,
   private catColoniasService: CatColoniasService,
   private catCallesService: CatCallesService,
   
  ) {}

  ngOnInit(): void {
    this.getAllCatDelegaciones();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), },
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridCatCalles();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getCatCallesByColonia(this.idColoniaSelect);} },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "Editar", ordenar: false, styleHeader: "width: 30px;"},
      {field: "descripcion", header: "Nombre Calle",ordenar: true, styleHeader: "width: 150px;",},
      {field: "acciones", header: "Eliminar",ordenar: false, styleHeader: "width: 30px;",},
    ];
  };
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    //verificamos si el input del filtro descripcion tiene valor para incar al usuario que limpie el filtro
    let descripcion = (<HTMLInputElement>document.getElementById("inputCalleFiltro"));
    if (descripcion.value !== "") {
      this.muestraMensaje.warning("Para agregar un nuevo registro, limpie el filtro de búsqueda.", "top", "center");
      return;
    }

    let catCallesNew = new CatCalles();
    catCallesNew.cambio = true;
    catCallesNew.id = 0;
    catCallesNew.numRow = this.catCalles.length + 1;
    catCallesNew.idColonia = this.idColoniaSelect !== 0 ? this.idColoniaSelect : null;
    this.catCalles.unshift(catCallesNew);
  };

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let catCallesEdit = event.data;
    this.clonedCatCalles[catCallesEdit.numRow] = { ...catCallesEdit };
    catCallesEdit.cambio = true;
    catCallesEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let catCallesEdit = event.data;
    let index = this.catCalles.findIndex(
      (obj) => obj.numRow === catCallesEdit.numRow
    );
    this.catCalles[index] = { ...this.clonedCatCalles[catCallesEdit.numRow]};
  };

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  };

  async onEditComplete(event) {
    try {
      let catCallesEdit = event.data;

      //Valida si hay cambios
      if (
        catCallesEdit.id === this.clonedCatCalles[catCallesEdit.numRow].id &&
        catCallesEdit.descripcion === this.clonedCatCalles[catCallesEdit.numRow].descripcion  &&
        catCallesEdit.idColonia === this.clonedCatCalles[catCallesEdit.numRow].idColonia
      ) {
        let index = this.catCalles.findIndex((obj) => obj.numRow === catCallesEdit.numRow);
        this.catCalles[index] = {...this.clonedCatCalles[catCallesEdit.numRow]};
        
        //Valida si la descripcion de la calle esta vacia
        if (catCallesEdit.descripcion === "" || catCallesEdit.descripcion === null || catCallesEdit.descripcion === undefined) {
          this.muestraMensaje.error("La descripción de la calle no puede estar vacía.", "top", "center");
          let index = this.catCalles.findIndex((obj) => obj.numRow === catCallesEdit.numRow);
          this.catCalles[index] = {...this.clonedCatCalles[catCallesEdit.numRow]};
          return;
      }
    }

      catCallesEdit.cambio = true;
      catCallesEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    }
  };
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  async guardarGridCatCalles() {
    try {
      this.progressBar = true;
      for (let catCallesFor of this.catCalles) {

        //Valida si la descripcion de la calle esta vacia
        if (catCallesFor.descripcion === "" || catCallesFor.descripcion === null || catCallesFor.descripcion === undefined) {
          throw new Error("La descripción de la calle no puede estar vacía.");  
        };

        if (catCallesFor.baja) {
          await this.deleteCatCalles(catCallesFor);
        } else if (catCallesFor.cambio) {
          catCallesFor.cambio = false;
          this.clonedCatCalles[catCallesFor.id] = { ...catCallesFor, };
          if (catCallesFor.id === 0) {
            const datoRetorno = await this.addCatCalles(catCallesFor);
            catCallesFor.id = datoRetorno.id;
          } else {
            await this.updateCatCalles(catCallesFor);
          };
        };
      };
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
      this.getCatCallesByColonia(this.idColoniaSelect);
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.progressBar = false;
    }
  }

  // prettier-ignore
  async addCatCalles(catCalles) {
    try {
      const datoretorno = await this.catCallesService
        .add(catCalles)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatCalles");
    }
  }

  // prettier-ignore
  async getAllCatCalles() {
    try {
      const datoRetorno = await this.catCallesService.getAll().toPromise();
      this.catCalles = datoRetorno;
      for (var i = 0, len = this.catCalles.length; i < len; ++i){
        this.catCalles[i].numRow = i;
        this.clonedCatCalles[this.catCalles[i].numRow] = {...this.catCalles[i],        };
      } 
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatCalles");
    }
  }

  // prettier-ignore
  async updateCatCalles(catCalles: CatCalles) {
    try {
      const datoRetorno = await this.catCallesService
        .update(catCalles)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatCalles");
    }
  }

  // prettier-ignore
  async deleteCatCalles(catCalles: CatCalles) {
    try {
      const datoRetorno = await this.catCallesService
        .delete(catCalles.id)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatCalles");
    }
  }

  //obtenemos catalogo de colonias
  async getColonias() {
    try {
      const datoRetorno = await this.catColoniasService.getAll().toPromise();
      this.catColonia = datoRetorno.map((catColonia) => {
        return { label: catColonia.descripcion, value: catColonia.id };
      });
      this.catColonia.unshift({ label: "Seleccione...", value: null });
    } catch (error) {
      this.muestraMensaje.error(error.message, "top", "center");
    }
  };

  // obtenemos el catalogo de delegaciones
  async getAllCatDelegaciones() {
    try {
      const datoRetorno = await this.catDelegacionesService.getAll().toPromise();
      this.catDelegaciones = datoRetorno.map((catDelegacion) => {
        return { label: catDelegacion.descripcion, value: catDelegacion.id };
      });

      this.catDelegaciones.unshift({ label: "Seleccione...", value: 0 });
    
    } catch (error) {
      this.muestraMensaje.error(error.message, "top", "center");
    };
  };

  //buscamos la colonia por delegacion:
  async getCatColoniasByDelgacion(idDelagacion: number) {
    try {
      this.catColonia = [];
      
      if (idDelagacion === 0 || idDelagacion === null || idDelagacion === undefined) {
        return;
      }

      const datoRetorno = await this.catColoniasService.getSingleDelegacion(idDelagacion).toPromise();
      this.catColonia = datoRetorno.map((catColonia) => {
        return { label: catColonia.descripcion, value: catColonia.id };
      });
      this.catColonia.unshift({ label: "Seleccione...", value: null });

      this.idDelegacionSelect = idDelagacion;

    } catch (error) {
    
    }
  }

  //buscamios calle por colonia
  async getCatCallesByColonia(idColonia: number) {
    try {
      this.catCalles = [];
      const datoRetorno = await this.catCallesService.getSingleColonias(idColonia).toPromise();
      //ordenamos por descripcion
      this.catCalles = datoRetorno.sort((a, b) => a.descripcion.localeCompare(b.descripcion));

      this.idColoniaSelect = idColonia;

    } catch (error) {
      this.muestraMensaje.error(error.message, "top", "center");
    }
  }
}